import $ from 'jquery';
import _throttle from 'lodash/throttle';
import { buildSlider } from '../utils/slider';

export default ($communityCarousels) => {
    $communityCarousels.each((i, el) => {
        const $slider = $(el).find('.com-car__slider');
        const $arrows = $(el).find('.com-car__slider-arrows');
        const buttonPrev =
            '<button class="com-car__slider__btn --prev"><span class="-hide-text">Previous</span><span class="icon-chevron-down"></span></button>';
        const buttonNext =
            '<button class="com-car__slider__btn --next"><span class="-hide-text">Next</span><span class="icon-chevron-down"></span></button>';

        const options = {
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            centerMode: true,
            centerPadding: '57px',
            appendArrows: $arrows,
            prevArrow: buttonPrev,
            nextArrow: buttonNext,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1900,
                    settings: {
                        slidesToShow: 7,
                        slidesToScroll: 7,
                        centerPadding: '40px',
                    },
                },
                {
                    breakpoint: 1740,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        centerPadding: '240px',
                    },
                },
                {
                    breakpoint: 1580,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        centerPadding: '160px',
                    },
                },
                {
                    breakpoint: 1420,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        centerPadding: '80px',
                    },
                },
                {
                    breakpoint: 1260,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        centerPadding: '40px',
                    },
                },
                {
                    breakpoint: 1180,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        centerPadding: '180px',
                    },
                },
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        centerPadding: '160px',
                    },
                },
                {
                    breakpoint: 1020,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        centerPadding: '140px',
                    },
                },
                {
                    breakpoint: 1060,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        centerPadding: '120px',
                    },
                },
                {
                    breakpoint: 980,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        centerPadding: '100px',
                    },
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        centerPadding: '80px',
                    },
                },
                {
                    breakpoint: 860,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        centerPadding: '60px',
                    },
                },
                {
                    breakpoint: 780,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        centerPadding: '40px',
                    },
                },
                {
                    breakpoint: 740,
                    settings: {
                        centerPadding: '240px',
                    },
                },
                {
                    breakpoint: 700,
                    settings: {
                        centerPadding: '220px',
                    },
                },
                {
                    breakpoint: 660,
                    settings: {
                        centerPadding: '200px',
                    },
                },
                {
                    breakpoint: 620,
                    settings: {
                        centerPadding: '180px',
                    },
                },
                {
                    breakpoint: 580,
                    settings: {
                        centerPadding: '160px',
                    },
                },
                {
                    breakpoint: 540,
                    settings: {
                        centerPadding: '140px',
                    },
                },
                {
                    breakpoint: 500,
                    settings: {
                        centerPadding: '120px',
                    },
                },
                {
                    breakpoint: 460,
                    settings: {
                        centerPadding: '100px',
                    },
                },
                {
                    breakpoint: 420,
                    settings: {
                        centerPadding: '80px',
                    },
                },
            ],
        };

        buildSlider($slider, options);
    });
};
